
let qryStrParams
function getParameters(): { [name: string]: string } {
  if (qryStrParams) {
    return qryStrParams
  }
  qryStrParams = {}
  if (window.location.search.indexOf('?') === 0) {
    const hashes = window.location.search.substring(1).split('&')
    for (let i = 0; i < hashes.length; i++) {
      // can't just splite '=' because the value can contains '=' as well
      const name = hashes[i].substring(0, hashes[i].indexOf('='))
      const value = hashes[i].substring(hashes[i].indexOf('=') + 1)
      qryStrParams[name] = decodeURIComponent(value)
    }
  }
  return qryStrParams
}


/**
 *  Builds a query string with the given params object.
 *  Query string output does not have beginning ?.
 *  Example: 'param1=val1&param2=value2&param3=value3'
 */
function buildQryString(params) {
  return Object.keys(params)
    .map(p => `${p}=${encodeURIComponent(params[p])}`)
    .join('&')
}

export function openWindow(url: string, name = '', width = 600, height = 400) {
  const top = (screen.height / 2) - 400
  const left = (screen.width / 2) - 600
  const windowDimensionsAndPosition = `width=600,height=400,top=${top},left=${left}`
  window.open(
    url,
    name,
    `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,${windowDimensionsAndPosition}`
  )
}

export default { buildQryString, getParameters, openWindow }
